import { ReactNode } from 'react';

import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';

interface WizardActionsProps {
  onBack: () => void;
  isFirst: boolean;
  primaryLabel: string;
  onPrimary: () => void;
  primaryDisabled?: boolean;
  loading?: boolean;
  /** Conteúdo extra à esquerda do botão primário (ex.: ação secundária). */
  secondary?: ReactNode;
}

/** Rodapé padrão dos passos do wizard: Voltar à esquerda, ação primária à direita. */
export function WizardActions({
  onBack,
  isFirst,
  primaryLabel,
  onPrimary,
  primaryDisabled = false,
  loading = false,
  secondary,
}: WizardActionsProps) {
  return (
    <div className="flex items-center justify-between pt-6">
      <Button type="button" variant="outline" onClick={onBack} disabled={isFirst || loading}>
        Voltar
      </Button>
      <div className="flex items-center gap-2">
        {secondary}
        <Button type="button" onClick={onPrimary} disabled={primaryDisabled || loading}>
          {loading && <Spinner size={16} className="mr-2 text-inherit" />}
          {primaryLabel}
        </Button>
      </div>
    </div>
  );
}
